import React, { useContext, useCallback } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import { ArchivalAidMetadata, ArchivalUnitCopy } from 'types';

import { ApiRoute } from 'enums';

import useFetch from 'utils/use-fetch';

import { GridActionButtonComponent } from 'components/grid/grid-types';
import { DialogContext } from 'components/dialog/dialog-context';
import { BasicQuoteDialog } from 'components/dialog/aisuk-dialogs/aisuk-basic-quote-dialog';

import { getArchivalUnitQuote } from './utils/get-archival-unit-quote';
import { findValidDescribingAidId } from 'components/grid/v2/context/hierarchy-context';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navigationButton: {
      marginTop: theme.spacing(),
      alignSelf: 'baseline',
      width: '100%',
    },
    dialog: {
      width: 600,
    },
    dialogTitle: {
      fontWeight: 'bold',
    },
    dialogActions: {
      padding: '8px 24px',
    },
    quote: {
      '& textarea': {
        lineHeight: 1.5,
      },
    },
  })
);

export function ArchivalUnitQuote({
  item,
  isEad,
  rootArchivalAid,
}: GridActionButtonComponent) {
  const classes = useStyles();
  const { open } = useContext(DialogContext);

  const archivalUnit = item as ArchivalUnitCopy;

  const archivalAidId = findValidDescribingAidId(
    archivalUnit?.archivalUnitReference?.describingArchivalAids
  );

  // this condition is to prevent fetch with 'undefined' id, when url is '', useFetch will return before fetch.
  const { data: archivalAid } = useFetch<ArchivalAidMetadata>(
    isEad && archivalAidId
      ? `/api/${ApiRoute.ARCHIVAL_AID}/${archivalAidId}`
      : ''
  );

  const handleOpenQuoteDialog = useCallback(() => {
    open({
      initialValues: {
        quoteContent: getArchivalUnitQuote(
          archivalUnit?.archivalUnitReference,
          archivalAid ?? rootArchivalAid,
          archivalUnit?.summary
        ),
      },
      size: 'sm',
      Content: BasicQuoteDialog,
    });
  }, [archivalAid, archivalUnit, open, rootArchivalAid]);

  return (
    <>
      <Button
        component="span"
        variant="outlined"
        color="primary"
        className={classes.navigationButton}
        onClick={handleOpenQuoteDialog}
      >
        Vytvoř citaci
      </Button>
    </>
  );
}
